import _slicedToArray from "@babel/runtime-corejs3/helpers/slicedToArray";
import isNumber from 'lodash/isNumber';
import { useState, useEffect, useRef } from 'react';
import useValueTexts from './use-value-texts';
export default function useHoverValue(valueText, _ref) {
  var format = _ref.format;
  var _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    value = _useState2[0],
    internalSetValue = _useState2[1];
  var ref = useRef();
  function setValue(val) {
    var immediately = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    isNumber(ref.current) && cancelAnimationFrame(ref.current);
    if (immediately) {
      internalSetValue(val);
      return;
    }
    ref.current = requestAnimationFrame(function () {
      internalSetValue(val);
    });
  }
  var valueTexts = useValueTexts(value, {
    format: format
  });
  function onEnter(date) {
    setValue(date);
  }
  function onLeave() {
    var immediately = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    setValue(null, immediately);
  }
  useEffect(function () {
    onLeave(true);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [valueText]);
  useEffect(function () {
    return function () {
      if (isNumber(ref.current)) {
        return cancelAnimationFrame(ref.current);
      }
    };
  }, []);
  return [valueTexts, onEnter, onLeave];
}